<button
  [class]="
    'pr-button ' +
    (clazz ? clazz + ' ' : '') +
    (display ? display + ' ' : '') +
    (size ? size : '')
  "
  [type]="type"
  (click)="click($event)"
  [attr.title]="tooltip ? tooltip : null"
  [disabled]="disabled"
>
  @if (icon) {
    <pr-icon
      [name]="icon"
      [ngClass]="{ 'show-s': label }"
      [width]="iconWidth"
      [viewBoxWidth]="iconViewBoxWidth"
      [viewBoxHeight]="iconViewBoxHeight"
    ></pr-icon>
  }
  @if (label) {
    <span
      class="pr-button-label-add"
      [ngClass]="{ 'hidden-s': icon, prn: rightIcon }"
      >{{ label }}</span
    >
  }
  @if (rightIcon) {
    <span class="right-icon">+</span>
  }
  @if (!label && !icon) {
    <div>
      <ng-content></ng-content>
    </div>
  }
</button>
